import React, { useState, useEffect } from 'react';
import './PWAInstallPrompt.css';

interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
  prompt(): Promise<void>;
}

const PWAInstallPrompt: React.FC = () => {
  return null;
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Controlla se l'app è già installata
    const checkIfInstalled = () => {
      if (window.matchMedia('(display-mode: standalone)').matches || 
          (window.navigator as any).standalone === true) {
        setIsInstalled(true);
      }
    };

    // Gestisce l'evento beforeinstallprompt
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
      setShowInstallPrompt(true);
    };

    // Gestisce l'evento appinstalled
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setShowInstallPrompt(false);
      setDeferredPrompt(null);
      console.log('PWA installata con successo!');
    };

    // Gestisce lo stato online/offline
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    checkIfInstalled();

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('Utente ha accettato l\'installazione');
    } else {
      console.log('Utente ha rifiutato l\'installazione');
    }
    
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
  };

  if (isInstalled) {
    return (
      <div className="pwa-status installed">
        <div className="pwa-status-content">
          <i className="fas fa-check-circle"></i>
          <span>App installata</span>
          {!isOnline && (
            <div className="offline-indicator">
              <i className="fas fa-wifi"></i>
              <span>Modalità offline</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (!showInstallPrompt) {
    return (
      <div className="pwa-status">
        <div className="pwa-status-content">
          {!isOnline && (
            <div className="offline-indicator">
              <i className="fas fa-wifi"></i>
              <span>Modalità offline</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="pwa-install-prompt">
      <div className="pwa-prompt-content">
        <div className="pwa-prompt-icon">
          <i className="fas fa-download"></i>
        </div>
        <div className="pwa-prompt-text">
          <h3>Installa Serpa App</h3>
          <p>Aggiungi l'app alla schermata principale per un accesso rapido e funzionalità offline.</p>
        </div>
        <div className="pwa-prompt-actions">
          <button className="pwa-btn pwa-btn-primary" onClick={handleInstallClick}>
            Installa
          </button>
          <button className="pwa-btn pwa-btn-secondary" onClick={handleDismiss}>
            Non ora
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt; 